module.exports = __webpack_public_path__ + "static/media/close-white.c2774e1a.svg";